import type { ScreenerSubField } from "epsm-api-types/models";
import type { Dispatch, SetStateAction } from "react";
import type { SingleValue } from "react-select";
import type { Option } from "@/interfaces/Option";
import type { ScorerColumn } from "../../type";
import { getColumnName } from "../Scorer";

export const updateDropdownWithSubfields = (
	column: ScorerColumn,
	value: SingleValue<Option>,
	allSubFields: Record<string, ScreenerSubField[]>,
	setScorerColumns: Dispatch<SetStateAction<ScorerColumn[]>>,
) => {
	const subfields = allSubFields[getColumnName(column)];

	if (!subfields || !subfields.length) return;

	const processSubfields = (
		subFields: ScreenerSubField[],
		parentPath = "",
	): ScreenerSubField[] => {
		return subFields
			?.map((subfield) => {
				const fullPath = parentPath
					? `${parentPath}.${subfield.name}`
					: subfield.name;
				const filteredSubFields = subfield.subFields?.length
					? processSubfields(subfield.subFields, fullPath)
					: [];
				if (value?.value === fullPath || filteredSubFields.length) {
					return {
						...subfield,
						...(filteredSubFields.length && {
							subFields: filteredSubFields,
						}),
					};
				}

				return null;
			})
			.filter((subfield) => subfield !== null);
	};

	const updatedSubfields = processSubfields(subfields);

	setScorerColumns((prev) =>
		prev.map((col) =>
			col.name === column.name
				? {
						...col,
						subFields: updatedSubfields,
					}
				: col,
		),
	);
};
